import styled from 'styled-components';

// variables
import { colors, fontSize } from './variables';

export const CardInfo = styled.div`
    width: 100%;
	height: ${props => (props.height ? props.height : 'fit-content')}
	background-color: ${props =>
    props.bg ? colors.grey.lightPrimary : colors.default};
	border-bottom: ${props =>
    props.border ? `1px dashed ${colors.grey.darkSecondary}` : 'none'};
    text-align: ${props => (props.textalign ? props.textalign : 'left')};
    padding: ${props => (props.padding ? '1rem' : '1rem 0')};
    margin: ${props => (props.margin ? props.margin : '0')};

    h3 {
        font-size: ${fontSize.md};
        color: ${colors.primary};
        font-weight: 600;
        margin-bottom: 1rem;
        text-transform: uppercase;
    }

    p {
        font-size: ${fontSize.sm};
        line-height: 1.5;

        strong {
            text-transform: uppercase;
        }

        &.title__info {
            color: ${colors.primary};
            font-size: ${fontSize.md};
            text-transform: uppercase;
        }

        &.feature,
        &.price {
            color: ${colors.secondary};
            font-weight: 600;
            text-transform: uppercase;
        }
    }

    & > ul {
        list-style: none;

        li {
            margin-bottom: 1rem;
            display: flex;
            flex-direction: column;

            span {
                line-height: 1.5;
                font-size: ${fontSize.sm};

                &:first-of-type {
                    color: ${colors.secondary};
                    margin-bottom: .5rem;
                }
            }
        }
    }

    @media (max-width: 768px) {
		margin-bottom: 1rem;
	}
`;

export const Additional = styled.div`
    width: 100%;
    height: ${props => (props.height ? props.height : 'fit-content')}
    border-bottom: ${props =>
    props.border ? `1px dashed ${colors.grey.darkSecondary}` : 'none'};
    text-align: ${props => (props.textalign ? props.textalign : 'left')};
    margin: ${props => (props.margin ? props.margin : '0')};

    .file-form {
        width: 100%;
        padding: 0;
    }

    label {
        color: ${colors.primary};
        padding: 0;
        margin-bottom: 1rem;
        font-weight: 700;
        text-align: left;
    }

    .file-form-btn {
        max-width: 100%;
    }

    p {
        text-align: left;
    }
`;

export const Info = styled.p`
  font-size: ${fontSize.md};
  color: ${colors.primary};
  line-height: 1.5;
`;
export const Desc = styled.span`
  margin-right: 0.3rem;
  text-transform: uppercase;
  font-weight: 700;
`;
export const Value = styled.span`
  &.price {
    color: ${colors.secondary};
    font-weight: 700;
  }
`;
